module.exports = __webpack_public_path__ + "img/bluetubesm.f576cd58.webp";